// QR Code Service - GraphQL operations for QR Codes
import { graphqlClient } from '../graphqlClient';

// ==================== Admin QR Codes ====================

export const getAllQRCodes = async () => {
  const query = `
    query GetAllQRCodes {
      getAllQRCodes {
        id
        qr_code_id
        qr_data
        amount
        currency
        reference
        client_name
        client_bank_name
        client_bank_account
        expires_at
        payment_id
        status
        metadata
        merchant_id
        merchant {
          id
          code
          email
          name
          status
          createdByAdminId
          createdByEngineId
          createdByResellerId
        }
        reseller {
          id
          code
          email
          name
          status
        }
        createdAt
        updatedAt
      }
    }
  `;

  const result = await graphqlClient.query(query);
  return result.getAllQRCodes || [];
};

// ==================== Merchant QR Codes ====================

export const getMerchantQRCodes = async () => {
  const query = `
    query GetMerchantQRCodes {
      getMerchantQRCodes {
        id
        qr_code_id
        qr_data
        amount
        currency
        reference
        client_name
        client_bank_name
        client_bank_account
        expires_at
        payment_id
        status
        metadata
        merchant_id
        createdAt
        updatedAt
      }
    }
  `;

  const result = await graphqlClient.query(query);
  return result.getMerchantQRCodes || [];
};


// ================== Merchant QR codes by id ====================

export const getQRCodesByMerchantId = async (merchantId) => {
  const query = `
    query GetQRCodesByMerchantId($merchantId: ID!) {
      getQRCodesByMerchantId(merchantId: $merchantId) {
        id
        qr_code_id
        qr_data
        amount
        currency
        reference
        client_name
        client_bank_name
        client_bank_account
        expires_at
        payment_id
        status
        metadata
        merchant_id
        createdAt
        updatedAt
      }
    }
  `;

  const result = await graphqlClient.query(query, { merchantId });
  return result.getQRCodesByMerchantId || [];
};
